import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["propertyId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { unitsRoutes } from './routes';
export class Units {
  constructor() {
    _defineProperty(this, "routes", unitsRoutes);
  }
  async updateUnits(data, options) {
    const buildingId = data.buildingId,
      units = data.units;
    const resp = await requestService('property').patch(this.routes.units(buildingId), units, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getUnits(data, options) {
    const resp = await requestService('property').get(this.routes.units(data.buildingId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getUnitsExtended(data, options) {
    var _data$statuses;
    const resp = await requestService('property').get(this.routes.unitsExtended(data.propertyId) + '?' + "".concat((_data$statuses = data.statuses) !== null && _data$statuses !== void 0 && _data$statuses.length ? data.statuses.map(n => "statuses=".concat(n)).join('&') + '&' : '') + "search=".concat(data.search), _objectSpread({}, options.cancelToken));
    return resp.data;
  }

  // ! not used
  async searchUnits(data, options) {
    const propertyId = data.propertyId,
      rest = _objectWithoutProperties(data, _excluded);
    const resp = await requestService('property').get(this.routes.search(propertyId), _objectSpread(_objectSpread({}, rest), options.cancelToken));
    return resp.data;
  }
  async getUnitById(data, options) {
    const resp = await requestService('property').get(this.routes.unitById(data.unitId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getUnitAvailabilityById(data, options) {
    const resp = await requestService('property').get(this.routes.unitAvailabilityById(data.unitId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}